// constants/reportConstant.js

// Get Reports
export const GET_REPORTS_REQUEST = 'GET_REPORTS_REQUEST'
export const GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS'
export const GET_REPORTS_FAIL = 'GET_REPORTS_FAIL'
export const GET_REPORTS_RESET = 'GET_REPORTS_RESET'

// Get Detailed Transactions
export const GET_DETAILED_TRANSACTIONS_REQUEST = 'GET_DETAILED_TRANSACTIONS_REQUEST'
export const GET_DETAILED_TRANSACTIONS_SUCCESS = 'GET_DETAILED_TRANSACTIONS_SUCCESS'
export const GET_DETAILED_TRANSACTIONS_FAIL = 'GET_DETAILED_TRANSACTIONS_FAIL'
export const GET_DETAILED_TRANSACTIONS_RESET = 'GET_DETAILED_TRANSACTIONS_RESET'

// Set Filter
export const SET_REPORT_FILTER_REQUEST = 'SET_REPORT_FILTER_REQUEST'
export const SET_REPORT_FILTER_SUCCESS = 'SET_REPORT_FILTER_SUCCESS'
export const SET_REPORT_FILTER_FAIL = 'SET_REPORT_FILTER_FAIL'
export const SET_REPORT_FILTER_RESET = 'SET_REPORT_FILTER_RESET'

// Export Reports
export const EXPORT_REPORTS_REQUEST = 'EXPORT_REPORTS_REQUEST'
export const EXPORT_REPORTS_SUCCESS = 'EXPORT_REPORTS_SUCCESS'
export const EXPORT_REPORTS_FAIL = 'EXPORT_REPORTS_FAIL'
export const EXPORT_REPORTS_RESET = 'EXPORT_REPORTS_RESET'

// Get Available Clubs for Reports
export const GET_AVAILABLE_CLUBS_REQUEST = 'GET_AVAILABLE_CLUBS_REQUEST'
export const GET_AVAILABLE_CLUBS_SUCCESS = 'GET_AVAILABLE_CLUBS_SUCCESS'
export const GET_AVAILABLE_CLUBS_FAIL = 'GET_AVAILABLE_CLUBS_FAIL'
export const GET_AVAILABLE_CLUBS_RESET = 'GET_AVAILABLE_CLUBS_RESET'

// Set Selected Club for Reports (Single Club - Legacy)
export const SET_SELECTED_CLUB = 'SET_SELECTED_CLUB'
export const CLEAR_SELECTED_CLUB = 'CLEAR_SELECTED_CLUB'

// Set Selected Clubs for Reports (Multi Club)
export const SET_SELECTED_CLUBS = 'SET_SELECTED_CLUBS'
export const CLEAR_SELECTED_CLUBS = 'CLEAR_SELECTED_CLUBS'